import {vars} from "../../vars.js";

export const headerAnimation = ()=> {
    if (vars.header) {
        vars.header.style.transform = 'translateY(0)'
    }
}